module.exports = __webpack_public_path__ + "static/media/gazit-logo.e4747426.png";